"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VinStockWrapper = exports.Vin = exports.VehicleTile = exports.UnlockLink = exports.Unit = exports.TileCTA = exports.Tile = exports.TabContainer = exports.Swatch = exports.StyledCompareVehicleToggle = exports.StockNum = exports.StatusMSRPText = exports.StatusMSRP = exports.StatusLabel = exports.StatusFilterLabel = exports.StatusFilter = exports.StatusContainer = exports.Status = exports.PreviouslyViewed = exports.NameWrapper = exports.Name = exports.MSRPLinksContainer = exports.MSRPCopy = exports.MSRPContainer = exports.MSRPContactCopy = exports.MSRP = exports.JellyWrapper = exports.Jelly = exports.IsPendingContainer = exports.IsPending = exports.InventoryStatus = exports.Icon = exports.FlexText = exports.FlexRow = exports.FlexContainerColumn = exports.FlexContainer = exports.FilterTooltipSubheader = exports.FilterTooltipListingWrapper = exports.FilterTooltipListingContent = exports.FilterTooltipList = exports.FilterTooltipHeader = exports.FilterTooltipContainer = exports.Divider = exports.Description = exports.DealerName = exports.DealerInfo = exports.DealerIconContainer = exports.DealerIcon = exports.DealerDistance = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../../../applications/SearchInventoryTool/atoms/CompareVehicleToggle/index.styled");
var _index2 = _interopRequireDefault(require("../../LexusButton/index.styled"));
var _Link = _interopRequireDefault(require("../../Link"));
var _index3 = _interopRequireDefault(require("../../MediaComponent/index.styled"));
var _index4 = _interopRequireDefault(require("../../PriceFormat/index.styled"));
var _breakpoints = _interopRequireDefault(require("../../breakpoints"));
const Tile = exports.Tile = _styledComponents.default.div`
  height: 100%;
  box-sizing: border-box;
`;
const VehicleTile = exports.VehicleTile = _styledComponents.default.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  height: 100%;
  .react-tabs__tab-list{
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      list-style-type: none;
      margin: 0;
      padding: 0;
      li {
        cursor: pointer;
        border-bottom: 2px solid #D8D8D8;
        width: 50%;
        padding-bottom: 13px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.react-tabs__tab--selected{
          border-bottom: 2px solid black;
        }
      }
    }
    .react-tabs__tab-panel {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .react-tabs__tab-panel--selected {
      padding-bottom: 16px;
      min-height: 214px;
    }
`;
const Name = exports.Name = _styledComponents.default.div`
  margin: 0 0 14px;
  height: 100%;
  min-height: 2.7em;
`;
const IsPendingContainer = exports.IsPendingContainer = _styledComponents.default.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const IsPending = exports.IsPending = _styledComponents.default.div`
  padding: 7px 7px;
  display: flex;
  justify-content:center;
  align-items: center;
  border-radius: 2px;
  background-color: #000;
  color:white;
  width: fit-content;
`;
const TabContainer = exports.TabContainer = _styledComponents.default.div`
  text-align: center;
`;
const Jelly = exports.Jelly = _styledComponents.default.div`
  position: relative;
  aspect-ratio: 17/9;
`;
const JellyWrapper = exports.JellyWrapper = _styledComponents.default.div`
  height: 100%;
  width: 100%;
  div{
    height: 100%;
    img{
      max-width: 450px;
      margin: 0 auto;
      min-height: 182px;
      ${(0, _breakpoints.default)("desktop", "up")} {
        transform: translateY(0px);
      }
    }
  }
`;
const Status = exports.Status = _styledComponents.default.div`
  text-align: left;
  display: flex;
  justify-content: space-between;
  button {
    background: none;
    text-decoration: underline;
    letter-spacing: inherit;
    color: inherit;
  }
`;
const StatusContainer = exports.StatusContainer = _styledComponents.default.div`
  align-items: center;
`;
const StatusFilter = exports.StatusFilter = _styledComponents.default.div`
  flex-direction: column; 
  align-items: flex-start;
`;
const StatusLabel = exports.StatusLabel = _styledComponents.default.div`
`;
const StatusFilterLabel = exports.StatusFilterLabel = _styledComponents.default.div`
`;
const StatusMSRPText = exports.StatusMSRPText = _styledComponents.default.div``;
const PreviouslyViewed = exports.PreviouslyViewed = _styledComponents.default.div`
  display: grid;
  place-items: center;
`;
const StatusMSRP = exports.StatusMSRP = _styledComponents.default.span`
  &.hasStatus {
    padding-left: 10px;
    margin-left: 10px;
  }
  ${_index4.default.Price} {
    font: inherit;
  }
  ${_index4.default.Symbol} {
    font: inherit;
    margin-left: 3px;
  }
`;
const Swatch = exports.Swatch = _styledComponents.default.div`
  ${function (_ref) {
  let {
    $hex
  } = _ref;
  return `background-color: #${$hex};`;
}}
  ${_index3.default.ImgDom} {
    object-position: 0;
    aspect-ratio: 1/1;
  }
`;
const Description = exports.Description = _styledComponents.default.div`
  margin: 0 0 16px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 3.4em;
`;
const Divider = exports.Divider = _styledComponents.default.div`
  height: 1px;
  width: 100%;
  background: #D8D8D8;
  margin-bottom: 16px;
  flex-shrink: 0;
`;
const FlexContainer = exports.FlexContainer = _styledComponents.default.div`
  display: flex;
`;
const FlexContainerColumn = exports.FlexContainerColumn = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
`;
const FlexRow = exports.FlexRow = _styledComponents.default.div`
  display: flex;
  align-items: flex-start;
`;
const FlexText = exports.FlexText = _styledComponents.default.div`
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
const Icon = exports.Icon = _styledComponents.default.span`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
`;
const MSRPContainer = exports.MSRPContainer = _styledComponents.default.div``;
const Unit = exports.Unit = _styledComponents.default.span``;
const MSRP = exports.MSRP = _styledComponents.default.div`
  display: flex;
  ${_index4.default.Price} {
    display: flex;
  }
`;
const MSRPContactCopy = exports.MSRPContactCopy = _styledComponents.default.span`
  min-height: 28px;
`;
const MSRPCopy = exports.MSRPCopy = _styledComponents.default.div`
  color: #000;
`;
const MSRPLinksContainer = exports.MSRPLinksContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
`;
const DealerInfo = exports.DealerInfo = _styledComponents.default.div`
  margin-bottom: 24px;
`;
const DealerName = exports.DealerName = _styledComponents.default.div`
  display: flex;
  &.hasDealerIcon { 
    margin-bottom: 8px;
  }
`;
const DealerDistance = exports.DealerDistance = _styledComponents.default.div`
  color: #000;
  white-space: nowrap;
  margin: 0 0 0 4px;
`;
const DealerIconContainer = exports.DealerIconContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  &.hasNoDealerIcon { 
    visibility: hidden;
  }
`;
const DealerIcon = exports.DealerIcon = _styledComponents.default.img`
  margin-right: 5px;
`;
const TileCTA = exports.TileCTA = _styledComponents.default.div`
  text-align: center;
  ${_index2.default.A}, ${_index2.default.Button} {
    width: 100%;
    padding: 10px 8px;
  }
`;
const InventoryStatus = exports.InventoryStatus = _styledComponents.default.div`
  color: #000;
`;
const NameWrapper = exports.NameWrapper = _styledComponents.default.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
const VinStockWrapper = exports.VinStockWrapper = _styledComponents.default.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 4px;
`;
const Vin = exports.Vin = _styledComponents.default.div`
`;
const StockNum = exports.StockNum = _styledComponents.default.div`
`;
const UnlockLink = exports.UnlockLink = (0, _styledComponents.default)(_Link.default)``;
const FilterTooltipContainer = exports.FilterTooltipContainer = _styledComponents.default.div``;
const FilterTooltipHeader = exports.FilterTooltipHeader = _styledComponents.default.div``;
const FilterTooltipListingContent = exports.FilterTooltipListingContent = _styledComponents.default.div``;
const FilterTooltipListingWrapper = exports.FilterTooltipListingWrapper = _styledComponents.default.div``;
const FilterTooltipSubheader = exports.FilterTooltipSubheader = _styledComponents.default.div``;
const FilterTooltipList = exports.FilterTooltipList = _styledComponents.default.ul``;
const StyledCompareVehicleToggle = exports.StyledCompareVehicleToggle = _styledComponents.default.div`
  margin-top: auto;
  ${_index.CompareVehicleToggle} {
    margin-top: 16px;
  }
`;